import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Invoice } from '../components/planDeTraitement/facturation/facturation.component';
import { Context } from '../shared/services/context.service';



@Injectable({ providedIn: 'root' })
export class InvoiceService {

   private readonly baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  save(invoice: Invoice, idTreatement: number) {
    return this.http.post(`${this.baseUrl}invoices/${idTreatement}`, invoice);
  }

  getAll() {
    return this.http.get<Invoice[]>(this.baseUrl + 'invoices/');
  }


  getById(id: number) {
  return this.http.get<Invoice>(`${this.baseUrl}invoices/${id}`);
}
  update(invoice: Invoice) {
  return this.http.put<Invoice>(`${this.baseUrl + 'invoices/'}${invoice.id}`, invoice);
}
}
